//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'SavingContent',
  components: {
    BaseImg: () => import('@motionelements/core/src/components/ui/BaseImg.vue'),
  },
  data() {
    return {
      img: 'https://static.moele.me/img/channels2022/user-guide/begin-saving-content.230328.png?auto=format&w=580',
      imgShadow: 'https://static.moele.me/img/channels2022/user-guide/begin-saving-content.230328.svg',
      imgDark: 'https://static.moele.me/img/channels2022/user-guide/begin-saving-content-invert.230328.png?auto=format&w=580',
      imgDarkShadow: 'https://static.moele.me/img/channels2022/user-guide/begin-saving-content-invert.230328.svg',
    };
  },
};
